<template>
    <div class="container">
        <div class="content">
            <div class="forms">
                <el-form :inline="true" :model="form" ref="form" class="search-form" size="small" label-width="64px">
                    <el-form-item label="班次名称">
                        <el-input  class="inline-input" v-model="form.name"  placeholder="请输入内容" 
                        clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div style="display: flex;">
                            <div class="s-btn" @click="fetchData('search')">查询</div>
                            <div class="r-btn" @click="fetchData('reset')">重置</div>
                        </div>
                    </el-form-item>

                </el-form>
                <div class="line"></div>
                <div class="data-title">
                    <div style="display: flex;height: 32px;">
                        <div class="title-line"></div>
                        <div class="title-name">数据列表</div>
                    </div>

                    <div class="title-btn">
                        <div class="title-btn-item" @click="onAdd" v-if="parArray.includes('add_shift')">
                            <i class="el-icon-plus"></i>
                            <div class="btn-l">新增班次</div>
                        </div>
                    </div>
                </div>
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.pageTotal"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10,20,30,50,200,2000]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange" v-loading="loading">
                </lb-table>
            </div>
        </div>
        <pop-delete ref="popDelete" title="是否确认删除？" @setDelete="setDelete" />
        <pop-tips ref="popTips" title="不可删除已绑定考勤组的班次" buttonText="已知悉" />
    </div>
</template>
<script>
import eldate from "@/components/eldate.vue";
import LbTable from "@/components/lb-table/lb-table";
import popDelete from "@/pages/assetManagement/common/popDelete";
import popTips from "@/pages/assetManagement/common/popTips";
import { formatHourMinute  } from "@/utils/index.js";
export default {
    name: "shiftList",
    components: {  eldate, LbTable,popDelete,popTips },
    data() {
        return {
            form: {
                name: '', 

            },
            currentId:'',
            page: {
                pageNo: 1,
                pageSize: 10,
                pageTotal:0,
            },
            list: [],
            loading:false,
            totalNum: 0,
            parArray: [],
            columns: [
                { label:'序号', type: 'index', width: '80' },
                { label: '班次名称', prop: 'name', minWidth: '200',
                    render: (h, scope) => {
                        const { name } = scope.row;
                        return (
                            <div class='align-left'>
                                {name}
                            </div>
                        )
                    }
                },
                { label: '考勤时间', prop: 'createdTime', minWidth: '160',
                    render: (h, scope) => {
                        return (
                            <div class='align-left'> {formatHourMinute(scope.row.clockInTime)}  -  {formatHourMinute(scope.row.clockOutTime)}</div>
                        )
                    }
                },
                {
                    label: '操作', prop: 'orgName', width: '100', fixed: 'right',
                    render: (h, scope) => {
                        const editButton = <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.onEdit(scope.row, scope.$index) }} >编辑</div>
                        const delButton = <div style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.onDelete(scope.row, scope.$index) }} >删除</div>
                        const vv = (<div style="display:flex;">
                            {this.parArray.includes('edit_shift') ? editButton : ''}
                            {this.parArray.includes('delete_shift') ? delButton : ''}
                        </div >)
                        return vv
                    }
                },
            ]
        }
    },
    activated() {
        
        this.fetchData();
    },
    created() {
        // 权限设定判断 
        const limits = JSON.parse(sessionStorage.getItem("limit"))
        const params = limits.buttonTreeDto.find(
            (item) => item.menuCode === "attendanceManagementList"
        )
        params && params.buttonList.forEach((item) => {
            this.parArray.push(item.code)
        })
    },
    methods: {

        fetchData(type) {
            if (type == 'reset') {
                this.form = {
                    name: '',
                }
                this.page = {
                    pageNo: 1,
                    pageSize: 10,
                    pageTotal:0,
                }
            }
            if (type == 'search') {
                this.form.pageNo = 1
            }
             this.form.pageNo = this.page.pageNo
            this.form.pageSize = this.page.pageSize
            this.loading = true
            this.$api.shiftsList(this.form).then(res => {
                if (res.code == 0) {
                    const data = res.data || {}
                    this.list = data.records || []
                    this.page.pageTotal = data.total
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.loading = false
            })
        },
       
        handleSizeChange(e) {
            this.page.pageSize = e
            this.fetchData()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e
            this.fetchData()
        },
         onMultipleSelection(val) {
            // if (val.length == this.page.pageSize) {
            //     this.form.allFlag = 1
            // }
            if (val) {
                this.form.ids = val.map((item) => {
                    return item.id
                })
            }

        },
        onAdd() {
            this.$router.push({ name: 'attendanceManagementListAdd' })
        },
        onEdit(val) {
            this.$router.push({ name: 'attendanceManagementListEdit', query: { id: val.id } })
        },
        onDelete(item, index) {
            // 当前绑定考勤组数量 boundGroupCount 判断是否可删除
            if (item.boundGroupCount == 0) {
                this.currentId = item.id
                this.$refs.popDelete.show()
            }else {
                this.$refs.popTips.show()
            }
            
        },
        setDelete(){
          this.$api.shiftsDelete(this.currentId).then((res) => {
            if (res.code == 0) {
              this.fetchData()
            }
          }).finally(() => {
          })
        }
        
    }

}
</script>
<style lang="scss" src="@/pages/attendanceManagement/common/style/common.scss" scoped />